import {
  TbFileInvoice,
  TbHeart,
  TbIdBadge2,
  TbList,
  TbShield,
  TbThumbUp,
  TbUserCircle,
} from 'react-icons/tb'

export const workspaceMenuItems = [
  {
    name: 'Minha conta',
    url: '/workspace',
    icon: TbUserCircle,
  },
  {
    name: 'Meus dados',
    url: '/workspace/meus-dados',
    icon: TbIdBadge2,
  },
  {
    name: 'Atividades',
    url: '/workspace/atividades',
    icon: TbList,
  },
  {
    name: 'Favoritos',
    url: '/workspace/favoritos',
    icon: TbHeart,
  },
  {
    name: 'Minhas solicitações',
    url: '/workspace/minhas_solicitacoes',
    icon: TbFileInvoice,
  },
  {
    name: 'Privacidade',
    url: '/workspace/privacidade',
    icon: TbShield,
  },
  {
    name: 'Pesquisa de satisfação',
    icon: TbThumbUp,
    url: '/pesquisa_satisfacao',
  },
]
